<template>
  <div class="card" @click.prevent="playVideo" @mouseover="hover = true" @mouseleave="hover = false">
    <div class="card__image-container">
      <img :src="video.thumbnail" :alt="video.description"/>
      <play-icon size="4x" class="play-icon" v-if="hover"/>
    </div>
    <div class="card__content">
      <p class="card__title">
        {{ video.title }}
      </p>
      <div style="text-align: center">
        <span v-for="tag in video.tags" :key="tag" class="chip" :style="`background-color: ${getColor(tag)}`">{{ tag }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { tagMapping } from '@/utils.js';
import { PlayIcon } from 'vue-feather-icons';

export default {
  name: "EmbeddedVideo",
  props: { video: Object },
  components: { 'play-icon': PlayIcon },
  methods: {
    playVideo() {
      this.$root.$emit('playvideo', 'youtube', this.video.link, this.video.size)
    },
    getColor(tag) {
      return tagMapping[tag];
    }
  },
  data: function () {
    return {
      hover: false
    }
  }
}
</script>

<style scoped>
.card {
  grid-column-end: span 4;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  transition: all 0.3s ease 0s;
  margin-top: 16px;
}
.card:hover {
  transform: translateY(-7px);
}
.card__image-container {
  width: 100%;
  padding-top: 56.25%;
  overflow: hidden;
  position: relative;
  background-color: black;
}
.card__image-container img {
  width: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.play-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
}
.card__content {
  padding-top: 8px;
}
.card__title {
  color: #575B68;
  font-size: 16px;
  font-weight: 400;
  margin-top: 8px;
  margin-bottom: 4px;
}
.chip {
  border-radius: 16px;
  font-size: 12px;
  padding: 2px 8px 2px 8px;
  margin-right: 4px;
}

@media only screen and (max-width: 1000px) {
  .card {
    grid-column-end: span 6;
  }
}
@media only screen and (max-width: 700px) {
  .card {
    grid-column-end: span 12;
  }
}
@media only screen and (max-width: 500px) {
  .card {
    grid-column-end: span 6;
  }
}
</style>